import { CHANNEL } from 'src/data/channel';
import {
  ADS_CHANNELS,
  EMAILS_CHANNELS,
  RESOURCE_DOCUMENTS,
  REVIEWS_CHANNELS,
  SOCIAL_CHANNELS,
  WEBSITE_CHANNELS,
} from './const';
import { RESOURCE_DOCUMENT } from './resources';

const ADS_ORIGIN = ADS_CHANNELS.reduce((a, v) => ({ ...a, [v]: v }), {});
const REVIEWS_ORIGIN = REVIEWS_CHANNELS.reduce((a, v) => ({ ...a, [v]: v }), {});
const WEBSITE_ORIGIN = WEBSITE_CHANNELS.reduce((a, v) => ({ ...a, [v]: v }), {});
const EMAILS_ORIGIN = EMAILS_CHANNELS.reduce((a, v) => ({ ...a, [v]: v }), {});
const SOCIAL_ORIGIN = SOCIAL_CHANNELS.reduce((a, v) => ({ ...a, [v]: v }), {});
const DOCUMENTS_ORIGIN = RESOURCE_DOCUMENTS.reduce((a, v) => ({ ...a, [v]: v }), {});

export const SUGGESTED_ANNOTATIONS_ORIGIN = {
  anyword: 'anyword',
  ...ADS_ORIGIN,
  ...REVIEWS_ORIGIN,
  ...WEBSITE_ORIGIN,
  ...EMAILS_ORIGIN,
  ...SOCIAL_ORIGIN,
  ...DOCUMENTS_ORIGIN,
};

export const USER_ANNOTATIONS_ORIGIN = 'user';

const SUGGESTED_ANNOTATIONS_ORIGIN_PROPS = {
  [SUGGESTED_ANNOTATIONS_ORIGIN.anyword]: {
    label: "Anyword's data",
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.google]]: {
    label: 'Google Ads',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.facebook]]: {
    label: 'Meta Ads',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.linkedin]]: {
    label: 'LinkedIn Ads',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.amazon]]: {
    label: 'Amazon Reviews',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.trustpilot]]: {
    label: 'Trustpilot',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.homepage]]: {
    label: 'Homepage',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.landingPage]]: {
    label: 'Landing Pages',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.competitors]]: {
    label: 'Competitors',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.thoughtLeadership]]: {
    label: 'Thought Leadership',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.productPage]]: {
    label: 'Product Page',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.other]]: {
    label: 'Other',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.hubspot]]: {
    label: 'HubSpot',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.facebookPages]]: {
    label: 'Facebook Page',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.instagram]]: {
    label: 'Instagram Posts',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[RESOURCE_DOCUMENT.emailCsvResource]]: {
    label: 'Email performance report',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[RESOURCE_DOCUMENT.emailSubjectLineCsvResource]]: {
    label: 'Email - Subject Line performance report',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[RESOURCE_DOCUMENT.emailColdCsvResource]]: {
    label: 'Email - Cold performance report',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[RESOURCE_DOCUMENT.emailPromotionCsvResource]]: {
    label: 'Email - Promotion performance report',
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[RESOURCE_DOCUMENT.googleDocs]]: {
    label: 'Google docs',
  },
};

export const getSuggestedAnnotationsOriginLabel = (origin) =>
  SUGGESTED_ANNOTATIONS_ORIGIN_PROPS[origin]?.label;

export const getDefaultSuggestedAnnotationsOrigin = (isAppModeInfinity) =>
  isAppModeInfinity
    ? SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.google]
    : SUGGESTED_ANNOTATIONS_ORIGIN.anyword;
